import React from 'react';

import ACGEndPage from './ACGEndPage';
import BTPEndPage from './BTPEndPage';
import DisneyEndPage from './DisneyEndPage';
import { customComponentIdOf } from './customPages';
import AdvanceButton from '../other_components/AdvanceButton';

/**
 * LA LIAISON id → composant, et le rendu d'une page de type `custom`.
 *
 * C'est le SEUL fichier qui importe les écrans custom eux-mêmes. Les
 * métadonnées (libellé, icône, description) vivent à côté, dans customPages.js,
 * que le builder lit sans embarquer chart.js ni d3 — cf. le commentaire là-bas.
 * Les clés de cette table sont celles du registre : ajouter un écran, c'est une
 * entrée de chaque côté.
 *
 * LE REPLI EST VISIBLE, JAMAIS `null`. Un identifiant qui ne résout plus
 * (composant retiré, faute de frappe, registre et table désaccordés) est
 * exactement le trou par lequel les écrans blancs de fin de partie sont
 * arrivés. Une page custom qui ne sait pas quoi montrer le DIT, en salle comme
 * dans le composeur.
 *
 * `pageData` est transmis en plus de `gameStatus` : les écrans actuels n'en
 * lisent rien, mais c'est par `content.metadata` que passera leur
 * dé-durcissement.
 */
const CUSTOM_COMPONENTS = {
  btp_summary: BTPEndPage,
  disney_summary: DisneyEndPage,
  acg_summary: ACGEndPage,
};

const CustomPage = ({
  pageData,
  gameStatus,
  onDecisionSelect,
  displayButton = true,
  endsGame = false,
}) => {
  const componentId = customComponentIdOf(pageData);
  const Component = CUSTOM_COMPONENTS[componentId];

  if (!Component) {
    return (
      <div className="page-general-container">
        <div className="page-general-background-color"></div>
        <div className="page-main-content">
          <div className="custom-page-missing">
            <h2>Écran custom introuvable</h2>
            <p>
              Cette page demande le composant <code>{componentId || '(aucun)'}</code>,
              qui ne figure pas dans le registre des écrans custom.
            </p>
            {/* LE REPLI FAIT AVANCER. Un écran custom est une page de pile :
                s'il ne résout pas ET ne peut pas être dépassé, la séance est
                bloquée là, sans recours possible depuis la salle. */}
            <AdvanceButton
              pageData={pageData}
              onDecisionSelect={onDecisionSelect}
              displayButton={displayButton}
              endsGame={endsGame}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Component
      pageData={pageData}
      gameStatus={gameStatus}
      onDecisionSelect={onDecisionSelect}
      displayButton={displayButton}
      endsGame={endsGame}
    />
  );
};

export default CustomPage;
